import { useMemo } from "react";
import { MRT_ColumnDef } from "mantine-react-table";
import { Badge, Tooltip, ActionIcon } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { getRegtankColor } from "../../../../Utils/getRegtankDetails";
import { RegtankOnboardingFHStatusEnum } from "@funded-here-interface/common/src/constant/enum";
import type { RegtankData } from "../Regtank.types";

/**
 * Column definitions for company onboarding table
 * Used for displaying onboarding status for company users (directors, shareholders, etc.)
 */
export const useOnboardingColumns = () => {
  return useMemo<MRT_ColumnDef<RegtankData>[]>(
    () => [
      {
        accessorKey: "name",
        header: "Full Name",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "userRole",
        header: "User Type",
      },
      {
        accessorKey: "onboardingStatus",
        header: "Verification Status",
        Header: ({ column }) => (
          <>
            <span>{column.columnDef.header}</span>
          </>
        ),
        Cell: ({ cell }) => (
          <Badge
            color={getRegtankColor(
              cell.getValue<RegtankOnboardingFHStatusEnum>()
            )}
          >
            {cell.getValue<RegtankOnboardingFHStatusEnum>()}
          </Badge>
        ),
      },
      {
        accessorKey: "lastAttemptDate",
        header: "Last Attempt On",
      },
      {
        accessorKey: "attemptUsed",
        header: "Attempt(s) Used",
        Header: ({ column }) => (
          <>
            <span>{column.columnDef.header}</span>
            <Tooltip
              label="Each verification attempt consists of 3 liveness checks"
              position="right"
              withArrow
            >
              <ActionIcon variant="transparent" color="gray">
                <IconInfoCircle size={20} />
              </ActionIcon>
            </Tooltip>
          </>
        ),
      },
    ],
    []
  );
};
